import Icon from '../components/Icon.vue'

Icon.register({
  icicles: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2L88.5 314.6C91 321.8 101.2 321.8 103.6 314.6L140 190.5 184.2 377.8C186.1 386.1 197.9 386.1 199.8 377.8L246.3 180.9 280.4 314.3C282.7 321.9 293.4 321.9 295.7 314.3L341.5 141.8 408.2 505.6C409.9 514.2 422.2 514.2 423.9 505.6L511.4 37.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/icicles.js
// module id = GDU0
// module chunks = 144